import React from 'react';
import {Chip, ChipIconContainer, ChipImage, ChipLabel, COLORS, SIZES} from '@fupa/fupa-uikit';
import styled from 'styled-components';

const Svg = styled.svg`
  fill: ${COLORS.grey};
  margin: auto;
  margin-right: ${SIZES[4]};
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: ${SIZES[24]};
  flex-shrink: 0;
`;

const SuggestChip = ({input, onDelete}) => {
  return (
    <Chip active={false}>
      <ChipIconContainer>
        <ChipImage circle type='search' entity='player' height={30} width={30} src={input.image} ratio='1:1' />
      </ChipIconContainer>
      <ChipLabel>{input.name}</ChipLabel>
      <Svg onClick={() => onDelete(input.slug)} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
        <path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' />
      </Svg>
    </Chip>
  );
};

export {SuggestChip};
